module.exports = __webpack_public_path__ + "img/text-classify3.1765de46.png";